const stepperStyles = {
	stepperContainer: {
		width: '100%',
		position: 'sticky',
	},
};

export default stepperStyles;